import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LEGACY_ORDERS_ROUTE = 'brand.orders'
const HESTIA_ORDERS_ROUTE = 'brand.apps.orders'

export const HESTIA_ORDERS_FEATURE_FLAG = 'hermes.hestiaOrders'

export const checkHestiaOrdersFeatureFlag: HermesGuardFn = async (to) => {
  if (to.name !== HESTIA_ORDERS_ROUTE) {
    return undefined
  }

  const featureFlags = useFeatureFlags()
  const hestiaOrdersEnabled = featureFlags.isEnabled(HESTIA_ORDERS_FEATURE_FLAG)

  if (!hestiaOrdersEnabled) {
    return {
      name: LEGACY_ORDERS_ROUTE,
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
